<template>
  <van-popup
    v-model:show="innerShow"
    position="right"
    :style="{ width: '100%', height: '100%' }"
  >
    <div class="user">
      <van-nav-bar
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="innerShow = false"
      />
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="state.major_id"
          :options="major"
          @change="dispatchUserList"
        />
        <van-dropdown-item
          v-model="state.online_state"
          :options="onlineState"
          @change="dispatchUserList"
        />
      </van-dropdown-menu>
      <div class="inner">
        <van-checkbox-group v-model="checked">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in list"
              clickable
              :key="item"
              :label="item.major_name"
              @click="toggle(index)"
            >
              <template #title>
                <span style="margin-right: 10px">{{ item.name }}</span>
                <van-tag
                  :type="item.online_state === '0' ? 'danger' : 'success '"
                  >{{ item.online_state_name }}</van-tag
                >
              </template>

              <template #right-icon>
                <van-checkbox
                  :name="item"
                  :ref="(el) => (checkboxRefs[index] = el)"
                  @click.stop
                />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>

      <van-button type="primary" block @click="submit">确定</van-button>
    </div>
  </van-popup>
</template>
<script>
import { useVModel } from "@vueuse/core";
import { reactive, ref, onBeforeUpdate } from "vue";
import { repairService, baseService } from "@/service";
import { Toast } from "vant";
export default {
  name: "User",
  props: {
    default: {
      type: Array,
    },
    title: {
      type: String,
      default: "选择派工人员",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:show", "submit"],
  setup(props, { emit }) {
    const state = reactive({
      pagesize: 999999,
      page: 1,
      major_id: "",
      online_state: "",
    });
    // 分组
    const major = ref([
      {
        text: "全部分组",
        value: "",
        faulttype_ids: "",
      },
    ]);

    const dispatchMajorList = async () => {
      const { data } = await repairService.dispatchMajorList();

      major.value.push(
        ...data.map((item) => ({
          text: item.major_name,
          value: item.id,
          faulttype_ids: item.faulttype_ids,
        }))
      );
    };
    dispatchMajorList();

    // 状态
    const onlineState = ref([
      {
        text: "全部状态",
        value: "",
      },
      {
        text: "在岗",
        value: "1",
      },
      {
        text: "不在岗",
        value: "0",
      },
    ]);

    // 筛选
    const list = ref([]);
    const checked = ref([]);
    const checkboxRefs = ref([]);
    const toggle = (index) => {
      checkboxRefs.value[index].toggle();
    };

    onBeforeUpdate(() => {
      checkboxRefs.value = [];
    });
    const dispatchUserList = async () => {
      try {
        const { data } = await baseService.dispatchUserList(state);
        list.value = data;
        if (props.default) {
          const arr = list.value.filter((item) =>
            props.default.includes(item.id)
          );
          checked.value = arr;
        }
      } catch (error) {
        list.value = [];
      }
    };
    dispatchUserList();
    // 提交
    const submit = () => {
      if (checked.value.length === 0) {
        Toast.fail("至少选择一个派工人员");
        return;
      }
      emit("update:show", false);
      emit("submit", checked.value);
    };
    return {
      state,
      major,
      onlineState,
      list,
      toggle,
      checked,
      checkboxRefs,
      dispatchUserList,
      submit,
      innerShow: useVModel(props, "show", emit),
    };
  },
};
</script>
<style lang="less" scoped>
.user {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .inner {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }
}
</style>
